import Layout from "components/Layout";
import React from "react";
import SiteEditForm from "./components/SiteEditForm";

function AdminSiteEditPage() {
  return (
    <Layout title="현장 수정/삭제">
      <SiteEditForm />
    </Layout>
  );
}

export default AdminSiteEditPage;
